export default __webpack_public_path__ + "static/media/backback.6569eb74.svg";